//@ts-ignore
import Swiper from "swiper";
const init = () => {
  const sliderContainer = document.querySelector('[data-filou-instagram-slider]') as HTMLElement;

  if (!sliderContainer) return;

  new Swiper(sliderContainer, {
    slidesPerView: "auto",
    spaceBetween: 16,
    loop: true,
  });
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    init();
  },
  {
    once: true,
  }
);
